<template>
  <v-dialog
    v-model="dialog"
    :max-width="value.header && value.header.length < 6 ? 850 : 1050"
    persistent
    transition="dialog-bottom-transition"
  >
    <template v-slot:activator="{ on, attrs }" v-if="value.header">
      <button
        class="btn btn-light-facebook btn-sm px-4 custom-btn text-no-wrap"
        @click="toggleModal"
      >
        View
      </button>
    </template>
    <div class="bg-white poppins">
      <v-card-text class="px-8 pt-6 pb-0">
        <div class="table-responsive">
          <table
            v-if="value.header"
            class="table table-head-custom table-vertical-center table-head-bg table-row-bordered poppins"
          >
            <thead>
              <tr>
                <th
                  class="pl-3"
                  v-for="(item, index) in value.header"
                  :key="index"
                >
                  <span class="text-dark-75">{{ item }}</span>
                </th>
              </tr>
            </thead>
            <tbody v-if="value.body.length > 0">
              <tr v-for="(item, index) in value.body" :key="index">
                <td
                  class="px-3 text-dark-65 font-weight-bolder font-size-lg"
                  v-for="(col, colIndex) in item"
                  :key="colIndex"
                >
                  {{ col }}
                </td>
              </tr>
            </tbody>
            <caption
              v-else
              class="mt-2 text-dark-50 text-center font-weight-bolder font-size-lg"
            >
              No Data
            </caption>
          </table>
        </div>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="pb-4">
        <v-spacer></v-spacer>
        <button
          type="reset"
          class="btn btn-light-info mr-3 px-5 py-3 ls1"
          @click="dialog = false"
        >
          Close
        </button>
      </v-card-actions>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: "ShowSkusTable",
  props: ["value"],
  data: () => ({
    dialog: false,
  }),
  methods: {
    toggleModal() {
      this.dialog = !this.dialog;
    },
  },
};
</script>
